import Vue from 'vue'
import { ActionContext, Module } from 'vuex'

import { RootState, MarketplaceState } from './state_models'

import { OauthService } from '../services'

let settingsPromise: Promise<any> | null = null // global lock within module

export const marketplace: Module<MarketplaceState, RootState> = {
  namespaced: true,
  state: {
    settings: {
      allowMarketplace: false,
      allowNewPublicApps: false,
      clientBlackList: [],
      company: '',
      enableLeadConnector: false,
      enableThirdParty: false,
      featureFlags: {},
      hideLabel: false,
      showAllApps: false,
    },
    settingsLoaded: false,
  },
  getters: {
    getSettings: (state: MarketplaceState) => {
      return state.settings;
    },
  },
  mutations: {
    setSettings: (state: MarketplaceState, payload: MarketplaceState['settings']) => {
      Vue.set(state, 'settings', payload)
    },
    setSettingsLoaded(state, loaded: boolean) {
      state.settingsLoaded = loaded;
    }
  },
  actions: {
    async fetchSettings(context: ActionContext<MarketplaceState, RootState>, companyId: string) {
      if (context.state.settingsLoaded) {
        return context.state.settings
      }

      if (!settingsPromise) {
        // 🧠 lock the promise once until it resolves
        settingsPromise = OauthService.getSettings(companyId)
          .then((settings) => {
            context.commit('setSettings', settings.config)
            context.commit('setSettingsLoaded', true)
            return settings.config
          })
          .catch((error) => {
            throw error
          })
          .finally(() => {
            settingsPromise = null // allow future refreshes if needed
          })
      }

      return settingsPromise
    },
    updateSettings(context: ActionContext<MarketplaceState, RootState>, settings: MarketplaceState['settings']) {
      context.commit('setSettings', settings);
    },
  },
}

